import { render, staticRenderFns } from "./UserRechargePage.vue?vue&type=template&id=0dd2c6c6&scoped=true"
import script from "./UserRechargePage.vue?vue&type=script&lang=js"
export * from "./UserRechargePage.vue?vue&type=script&lang=js"
import style0 from "./UserRechargePage.vue?vue&type=style&index=0&id=0dd2c6c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd2c6c6",
  null
  
)

export default component.exports